import { computed, reactive, readonly, toRefs } from "vue";
import { addServicesApi, amountServicesApi, selectServicesApi } from "@/api";
import {
  orderHash,
  orderServices,
  paidOrderServices,
  useYourOwnAmountServiceHash,
  isUseYourOwnAmountService
} from "@/stores/Order";
import { setGlobalMessage } from "@/stores/Global";
import {ecommerceAddToCart, ecommerceRemoveFromCart} from '@/utils/analytics'

const state = reactive({
  amount: [],
  select: [],
  cateringServices: []
});

let lastHash = null;
const orderSelectServiceById = [];

const modifyServiceData = service => {
  if (orderHash.value !== lastHash) {
    lastHash = orderHash.value;
    if (orderSelectServiceById.length) {
      orderSelectServiceById.splice(0, orderSelectServiceById.length);
    }
  }
  if (!orderSelectServiceById.length) {
    orderServices.value.forEach(service => {
      orderSelectServiceById[service.service_id] = service;
    });
  }

  const selectedServiceData = orderSelectServiceById[service.id] || null;

  service.selected_amount =
    (selectedServiceData && selectedServiceData.amount) || service.min_amount;
  service.selected = !!selectedServiceData;
  service.selected_item_id = null;

  if (service.items) {
    service.items.forEach(item => {
      item.selected =
        (selectedServiceData &&
          selectedServiceData.service_item_id === item.id) ||
        false;

      if (item.selected) {
        service.selected_item_id = item.id;
      }
    });
  }

  return service;
};

export async function loadAmountServices() {
  if (state.amount.length) {
    return {
      success: true
    };
  }
  const { success, services } = await amountServicesApi(orderHash.value);
  if (success) {
    const collect = [];

    services.forEach(service => {
      collect.push(modifyServiceData(service));
    });

    state.amount = collect;

    return {
      success,
      services
    };
  }

  return {
    success: false
  };
}

export async function loadSelectServices() {
  if (state.select.length) {
    return true;
  }
  const { success, services } = await selectServicesApi(orderHash.value);
  if (success) {
    const collect = [];

    services.forEach(service => {
      collect.push(modifyServiceData(service));
    });

    state.select = collect;

    return {
      success,
      services
    };
  }

  return {
    success: false
  };
}

export const amountServices = readonly(toRefs(state).amount);
export const paidAmountServices = computed(() => {
  const collect = [];

  const servicesById = {};
  state.amount.forEach(service => {
    servicesById[service.id] = service;
  });

  paidOrderServices.value.forEach(paidService => {
    const service = servicesById[paidService.service_id] || null;
    if (service && service.service_type === "amount") {
      collect.push({
        ...service,
        ...paidService,
        selected_amount: paidService.amount
      });
    }
  });
  return collect;
});

export const selectServices = readonly(toRefs(state).select);
export const paidSelectServices = computed(() => {
  const collect = [];

  const servicesById = {};
  state.select.forEach(service => {
    servicesById[service.id] = service;
  });

  paidOrderServices.value.forEach(paidService => {
    const service = servicesById[paidService.service_id] || null;
    if (service && service.service_type === "select") {
      collect.push({
        ...service,
        ...paidService,
        selected_amount: paidService.amount
      });
    }
  });

  return collect;
});

export function setSelectAmountService(id, amount = 0, selected) {
  console.log('setSelectAmountService')
  const index = state.amount.findIndex(service => service.id === id);
  if (index > -1) {
    if (amount) {
      state.amount[index].selected_amount = amount;
      state.amount[index].selected = selected;
      ecommerceAddToCart({
          products: [{
                id,
                name: state.amount[index].name,
                price: state.amount[index].price,
                discountPrice: 0,
                vat: 0,
                quantity: amount,
          }]
        })
    } else if (state.amount[index]) {
      ecommerceAddToCart({
          products: [{
                id,
                name: state.amount[index].name,
                price: state.amount[index].price,
                discountPrice: 0,
                vat: 0,
                quantity: amount,
          }]
        })
      state.amount[index].selected_amount = 0;
      state.amount[index].selected = false;
    }
  }
}

export async function addServices() {
  const services = [];

  if (isUseYourOwnAmountService.value) {
    services.push({
      hash: useYourOwnAmountServiceHash.value,
      amount: 1
    });
  } else {
    cateringServices.value.forEach(service => {
      if (service.selected) {
        let itemHash = "";

        if (service.selected_item_id) {
          const findItemIndex = service.items.findIndex(
            item => item.id === service.selected_item_id
          );

          if (findItemIndex > -1) {
            itemHash = service.items[findItemIndex].hash;
          }
        }

        services.push({
          hash: service.hash,
          amount: service.selected_amount,
          item_hash: itemHash
        });
      }
    });
  }

  state.select.forEach(service => {
    if (service.selected) {
      service.items.forEach(item => {
        if (item.selected) {
          services.push({
            hash: service.hash,
            amount: 1,
            item_hash: item.hash
          });
        }
      });
    }
  });

  const { success, message } = await addServicesApi(orderHash.value, services);

  if (!success && message) {
    setGlobalMessage(message);
  }

  return {
    success
  };
}

export function setSelectedSelectService(id, itemId, selected) {
  const index = state.select.findIndex(service => service.id === id);
  if (index > -1) {
    const itemIndex = state.select[index].items.findIndex(
      item => item.id === itemId
    );
    if (itemIndex > -1) {
      const anySelectedItemIndex = state.select[index].items.findIndex(
        item => item.selected === true
      );
      if (anySelectedItemIndex > -1) {
        state.select[index].items[anySelectedItemIndex].selected = false;
      }
      state.select[index].selected = selected;
      state.select[index].items[itemIndex].selected = selected;
      state.select[index].selected_item_id =
      state.select[index].items[itemIndex].id;

      const ecommerceData = {
            products: [
              {
                id: `${id}_${itemId}`,
                name: state.select[index].name,
                price: state.select[index].price,
                discountPrice: 0,
                vat: 0,
                quantity: 1,
              }
            ]
      }

      if(selected){
        ecommerceAddToCart({
          products: [ecommerceData]
        })
      } else {
        ecommerceRemoveFromCart({
          products: [ecommerceData]
        })
      }
    }
  }
}

export const loadCateringServices = async () => {
  if (state.cateringServices.length) {
    return {
      success: true
    };
  }

  const { success, services } = await amountServicesApi(orderHash.value);

  if (success) {
    const collect = [];

    services.forEach(service => {
      collect.push(modifyServiceData(service));
    });

    state.cateringServices = collect;

    return {
      success,
      services
    };
  }

  return {
    success: false
  };
};

export const cateringServices = computed(() => {
  return [...state.cateringServices].map(service => {
    let selected = false;

    if (!service.items.length && service.selected_amount) {
      selected = true;
    }

    if (service.items.length && service.selected_item_id) {
      selected = true;
    }

    return {
      ...service,
      selected_amount: service.selected_amount || 0,
      selected_item_id: service.selected_item_id || null,
      selected
    };
  });
});

export const paidCateringServices = computed(() => {
  const collect = [];

  const servicesById = {};
  state.cateringServices.forEach(service => {
    servicesById[service.id] = service;
  });

  paidOrderServices.value.forEach(paidService => {
    const service = servicesById[paidService.service_id] || null;
    if (service && service.service_type === "catering") {
      if (service.items.length) {
        service.items = service.items.map(item => {
          if (item.id === paidService.service_item_id) {
            return {
              ...item,
              name: paidService.item_name,
              price: paidService.price
            };
          }

          return {
            ...item
          };
        });
      }

      collect.push({
        ...service,
        ...paidService,
        selected_amount: paidService.amount,
        selected_item_id: paidService.service_item_id || null
      });
    }
  });
  return collect;
});

export const addSelectedCateringService = (id, itemId, amount) => {
  const itemIndex = state.cateringServices.findIndex(item => item.id === id);

  if (itemIndex > -1 && amount > 0) {
    state.cateringServices[itemIndex].selected_amount = amount;
    state.cateringServices[itemIndex].selected_item_id = itemId;
    ecommerceAddToCart({
          products: [{
                id: itemId ? `${id}_${itemId}` : id,
                name: state.cateringServices[itemIndex].name,
                price: state.cateringServices[itemIndex].price,
                discountPrice: 0,
                vat: 0,
                quantity: amount,
          }]
    })
  }
};

export const removeSelectedCateringService = (id, itemId) => {
  const itemIndex = state.cateringServices.findIndex(item => item.id === id);

  if (itemIndex > -1) {
    const eItemId = state.cateringServices[itemIndex].selected_item_id
        ecommerceRemoveFromCart({
          products: [{
                id: eItemId ? `${id}_${eItemId}` : id,
                name: state.cateringServices[itemIndex].name,
                price: state.cateringServices[itemIndex].price,
                discountPrice: 0,
                vat: 0,
                quantity: state.cateringServices[itemIndex].selected_amount,
          }]
    })
    state.cateringServices[itemIndex].selected_amount = 0;
    state.cateringServices[itemIndex].selected_item_id = null;
  }
};
